import ExtendedApplicationState from "@husky-hrc/Framework/Store/ExtendedApplicationState";
import { getById } from "@insite/client-framework/Store/Data/DataState";

export function getProductConfigStateByProductId(state: ExtendedApplicationState, productId: string | undefined) {
    return getById(state.productConfig, productId, id => state.productConfig.idByProduct[id]);
}

export function getProductConfigStateByConfigId(state: ExtendedApplicationState, configId: string) {
    return getById(state.productConfig, configId);
}
